import { BodhiTile } from "@bodhistreams/ui";
import "./ZonesSection.css";

const ZONES = [
	{
		label: "Reception & Lobby",
		sub: "Welcoming, ambient sound",
		tag: "Zone 01",
		color: "#6B9E8D",
	},
	{
		label: "Treatment Rooms",
		sub: "Calm, low-tempo flows",
		tag: "Zone 02",
		color: "#8B7B9D",
	},
	{
		label: "Relaxation Lounges",
		sub: "Slow, immersive textures",
		tag: "Zone 03",
		color: "#C9A876",
	},
	{
		label: "Yoga & Meditation",
		sub: "Breath-paced soundscapes",
		tag: "Zone 04",
		color: "#7EBBA3",
	},
	{
		label: "Fitness Studios",
		sub: "Energized wellness rhythms",
		tag: "Zone 05",
		color: "#D4847A",
	},
	{
		label: "Guest Suites & Villas",
		sub: "In-room calm by default",
		tag: "Zone 06",
		color: "#C9A5A0",
	},
];

const ZonesSection = () => (
	<section className="zones-section">
		<div className="zones-grid">
			<div>
				<span className="zones-copy-eyebrow">Multi-zone streaming</span>
				<h2 className="zones-copy-heading">
					Different rooms. Different moods. One platform.
				</h2>
				<p className="zones-copy-lead">
					Stream different playlists simultaneously across every area of your
					property — each space gets its own carefully selected soundtrack to
					enhance the guest journey.
				</p>
				<p className="zones-copy-note">
					Plug &amp; play setup: connect any Wi-Fi-enabled tablet, phone, or
					streaming device to your Bluetooth or wired speakers and start playing
					instantly. No technical expertise required.
				</p>
			</div>

			<div className="zones-tiles">
				{ZONES.map((zone) => (
					<BodhiTile
						key={zone.label}
						label={zone.label}
						sub={zone.sub}
						tag={zone.tag}
						color={zone.color}
					/>
				))}
			</div>
		</div>
	</section>
);

export default ZonesSection;
